import { Result } from "@/main/models/common/resultResponse";
import { UpdateHierarchyLevelRequest } from "@/main/models/request/hierarchyLevel";
import { AxiosResponse } from "axios";

export abstract class IHierarchyLevelApi {
	abstract update(request: UpdateHierarchyLevelRequest): Promise<AxiosResponse<Result<boolean>>>;
}
